import { useState } from "react";
import useBanner from "../../../../services/Inventory/useBanner";
import { useNavigate, useLocation } from "react-router-dom";
import NoIndex from "../../../../components/NoIndex";
import { ToastContainer } from "react-toastify";

export default function CreateNewBanner() {
 const navigate = useNavigate();
 const location = useLocation();

 const normalizePath = (path = "") => path.toLowerCase().replace(/\/+$/, "");

 const isCreateActive =
   normalizePath(location.pathname) === "/inventory/banner/create-new-banner";

  const { createBanner } = useBanner();
  const [formData, setFormData] = useState({
    title: "",
    cardType: "",
    status: "N",
    html: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = "Banner Title is required.";
    if (!formData.cardType) newErrors.cardType = "Banner Type is required.";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    createBanner(
      {
        title: formData.title,
        cardCount: formData.cardType,
        html: formData.html,
        status: formData.status,
      },
      navigate,
    );
  };

  return (
    <>
      <NoIndex />
      <ToastContainer />

      <div className="montserrat-font-1">
        <div
          style={{
            backgroundColor: "#f9fafb",
            minHeight: "100vh",
            padding: "24px 32px",
            color: "#111827",
          }}
        >
          {/* Page Header */}
          <div style={{ marginBottom: "20px" }}>
            <h1 style={{ fontSize: "22px", fontWeight: "600", margin: 0 }}>
              Banner Management
            </h1>
            <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "4px" }}>
              Create reusable banner templates that save time and ensure
              consistency
            </p>
          </div>

          {/* Tabs */}
          <div
            style={{
              display: "flex",
              gap: "24px",
              borderBottom: "1px solid #e5e7eb",
              marginBottom: "20px",
            }}
          >
            {["library", "create"].map((tab) => {
              const label =
                tab === "library" ? "Banner Library" : "Create Banner";

              const isActive =
                tab === "library"
                  ? normalizePath(location.pathname) === "/inventory/banner"
                  : normalizePath(location.pathname) ===
                    "/inventory/banner/create-new-banner";

              return (
                <button
                  key={tab}
                  onClick={() => {
                    navigate(
                      tab === "library"
                        ? "/inventory/banner"
                        : "/inventory/banner/create-new-banner",
                    );
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "8px 0",
                    fontSize: "14px",
                    fontWeight: isActive ? "600" : "400",
                    color: isActive ? "#16a34a" : "#6b7280",
                    borderBottom: isActive
                      ? "2px solid #16a34a"
                      : "2px solid transparent",
                    cursor: "pointer",
                    marginBottom: "-1px",
                  }}
                >
                  {label}
                </button>
              );
            })}
          </div>

          {/* Card */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              padding: "24px",
              maxWidth: "960px",
            }}
          >
            {/* Banner Title */}
            <div style={{ marginBottom: "18px" }}>
              <label style={labelStyle}>Banner Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                style={{
                  ...inputStyle,
                  borderColor: errors.title ? "#ef4444" : "#d1d5db",
                }}
              />
              {errors.title && (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#ef4444",
                    marginTop: "4px",
                  }}
                >
                  {errors.title}
                </p>
              )}
            </div>

            {/* Banner Type */}
            <div style={{ marginBottom: "18px" }}>
              <label style={labelStyle}>Banner Type</label>
              <div style={{ position: "relative" }}>
                <select
                  name="cardType"
                  value={formData.cardType}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      cardType: e.target.value,
                    }));
                    setErrors((prev) => ({ ...prev, cardType: "" }));
                  }}
                  style={{
                    ...inputStyle,
                    appearance: "none",
                    paddingRight: "36px",
                    color: formData.cardType ? "#111827" : "#9ca3af",
                    borderColor: errors.cardType ? "#ef4444" : "#d1d5db",
                  }}
                >
                  <option value="" disabled hidden>
                    Select...
                  </option>
                  <option value="single-carousel">Single Carousel</option>
                  <option value="multi-carousel">Multi Carousel</option>
                </select>
                <svg
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6b7280",
                  }}
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.085l3.71-3.854a.75.75 0 111.08 1.04l-4.25 4.42a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              {errors.cardType && (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#ef4444",
                    marginTop: "4px",
                  }}
                >
                  {errors.cardType}
                </p>
              )}
            </div>

            {/* Status Toggle */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Status</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "6px",
                }}
              >
                <div
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      status: prev.status === "Y" ? "N" : "Y",
                    }))
                  }
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "22px",
                    borderRadius: "999px",
                    backgroundColor:
                      formData.status === "Y" ? "#22c55e" : "#d1d5db",
                    cursor: "pointer",
                    transition: "background-color 0.25s",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "3px",
                      left: formData.status === "Y" ? "21px" : "3px",
                      width: "16px",
                      height: "16px",
                      borderRadius: "50%",
                      backgroundColor: "#ffffff",
                      transition: "left 0.25s",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "13px",
                    color: formData.status === "Y" ? "#16a34a" : "#6b7280",
                    fontWeight: "500",
                  }}
                >
                  {formData.status === "Y" ? "Active" : "Inactive"}
                </span>
              </div>
            </div>

            {/* Banner HTML */}
            <div style={{ marginBottom: "0" }}>
              <label style={labelStyle}>Banner HTML</label>
              <p
                style={{
                  fontSize: "12px",
                  color: "#9ca3af",
                  marginTop: "4px",
                  marginBottom: "10px",
                }}
              >
                If you don't have a banner link, open Editor mode to create a
                banner and generate the HTML link.
              </p>
              <div
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor: "#f9fafb",
                }}
              >
                <textarea
                  name="html"
                  rows={6}
                  value={formData.html}
                  onChange={handleChange}
                  placeholder="Place the code here!"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "none",
                    outline: "none",
                    resize: "vertical",
                    backgroundColor: "transparent",
                    fontSize: "13px",
                    color: "#3b82f6",
                    fontFamily: "monospace",
                    boxSizing: "border-box",
                  }}
                />
                <div
                  style={{
                    borderTop: "1px solid #e5e7eb",
                    padding: "8px 12px",
                    backgroundColor: "#f9fafb",
                  }}
                >
                  <button
                    onClick={() => navigate("/inventory/banner/html-editor")}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "13px",
                      color: "#3b82f6",
                      border: "1px solid #e5e7eb",
                      backgroundColor: "#ffffff",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                      <path d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                    </svg>
                    Open Editor mode
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#16a34a",
                  color: "#ffffff",
                  border: "none",
                  padding: "9px 20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                Create Banner
              </button>
              <button
                onClick={() => {
                  setFormData({
                    title: "",
                    cardType: "",
                    status: "N",
                    html: "",
                  });
                  setErrors({});
                }}
                style={{
                  backgroundColor: "#ffffff",
                  color: "#374151",
                  border: "1px solid #d1d5db",
                  padding: "9px 20px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "500",
  color: "#374151",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  fontSize: "14px",
  color: "#111827",
  outline: "none",
  boxSizing: "border-box",
  backgroundColor: "#ffffff",
};